





















































import _ from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { CheckedOutCustomersOnAccUnitType } from "./CheckOutModalForm.vue";
import DateField from "@/components/misc/DateField.vue";
import TimeField from "@/components/misc/TimeField.vue";

@Component({ components: { DateField, TimeField } })
export default class CheckOutGuestCard extends Vue {
  @Prop() eVisitorCheck?: boolean;
  
  guest: CheckedOutCustomersOnAccUnitType | null = null;

  @Prop() value?: CheckedOutCustomersOnAccUnitType;
  @Watch("value", { immediate: true, deep: true })
  valueChanged(fresh: CheckedOutCustomersOnAccUnitType) {
    if (_.isEqual(fresh, this.guest)) return;
    this.guest = fresh ? _.cloneDeep(fresh) : null;
  }

  @Watch("guest", { deep: true })
  dataChanged(fresh: CheckedOutCustomersOnAccUnitType) {
    this.$emit("input", fresh);
  }
  
  guestStatusDescriptionTR(g: CheckedOutCustomersOnAccUnitType) {
    if(g) {
      if(g.isCheckedOut) return "Reservation.Guest.CheckedOut";
      if(g.isCheckedIn) return "Reservation.Guest.CheckedIn";
    }
    return "Reservation.Guest.NotCheckedIn";
  }

  guestEVisitorStatusDescriptionTR(g: CheckedOutCustomersOnAccUnitType) {
    if(g) {
      if(g.eVisitorIsCheckedOut) return "Reservation.Guest.CheckedOut";
      if(g.eVisitorIsCheckedIn) return "Reservation.Guest.CheckedIn";
    }
    return "Reservation.Guest.NotCheckedIn";
  }
  
  get rules() {
    const required = (value: any) => !!value || this.$t("Validation.Required");
    const requiredIfCheckedAndEVisitor = (value: any) => {
      const r = required(value);
      return (this.guest?.checked && this.eVisitorCheck) ? r : true;
    };

    return {
      eVisitorRequired: [requiredIfCheckedAndEVisitor],
    };
  }
}
